import { isNilOrEmpty } from "../utils/isNilOrEmpty";
import { toValidCssValue } from "../utils/toValidCssValue";
export var getCssWidth = externalGap => {
  if (typeof externalGap === "string") {
    return "calc(100% - (".concat(externalGap, "))");
  }

  if (typeof externalGap === "number") {
    if (externalGap === 0) return "100%";
    return "calc(100% - ".concat(externalGap, "px)");
  }

  return "auto";
};
export var sumExternalGap = (a, b) => {
  if (isNilOrEmpty(a) && isNilOrEmpty(b)) return undefined;
  if (a === 0 && b === 0) return 0;
  if (!a && !isNilOrEmpty(b)) return b;
  if (!isNilOrEmpty(a) && !b) return a;
  return "".concat(toValidCssValue(a), " + ").concat(toValidCssValue(b));
};
export var createWidthInterface = externalGap => {
  return {
    value: externalGap,
    combine: w => createWidthInterface(sumExternalGap(externalGap, w.value)),
    getStyle: () => ({
      width: getCssWidth(externalGap)
    })
  };
};